import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  ActivateSubscription200,
  ActivateSubscriptionBody,
  CancelSubscription200,
  CancelSubscriptionBody,
  GetSubscriptionById200,
  GetSubscriptions200
} from './types'
import { customInstance } from '../custom-axios';


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * @summary 구독 목록 조회
 */
export const getSubscriptions = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetSubscriptions200>(
      {url: `/api/v1/subscriptions`, method: 'GET', signal
    },
      options);
    }
  

export const getGetSubscriptionsQueryKey = () => {
    return [`/api/v1/subscriptions`] as const;
    }

    
export const getGetSubscriptionsInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getSubscriptions>>, TError = unknown>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSubscriptions>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSubscriptionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubscriptions>>> = ({ signal }) => getSubscriptions(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSubscriptions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSubscriptionsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getSubscriptions>>>
export type GetSubscriptionsInfiniteQueryError = unknown

/**
 * @summary 구독 목록 조회
 */
export const useGetSubscriptionsInfinite = <TData = Awaited<ReturnType<typeof getSubscriptions>>, TError = unknown>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSubscriptions>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSubscriptionsInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetSubscriptionsQueryOptions = <TData = Awaited<ReturnType<typeof getSubscriptions>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSubscriptions>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSubscriptionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubscriptions>>> = ({ signal }) => getSubscriptions(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSubscriptions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSubscriptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getSubscriptions>>>
export type GetSubscriptionsQueryError = unknown

/**
 * @summary 구독 목록 조회
 */
export const useGetSubscriptions = <TData = Awaited<ReturnType<typeof getSubscriptions>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSubscriptions>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSubscriptionsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary 구독 상세 조회
 */
export const getSubscriptionById = (
    subscriptionId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetSubscriptionById200>(
      {url: `/api/v1/subscriptions/${subscriptionId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetSubscriptionByIdQueryKey = (subscriptionId: string,) => {
    return [`/api/v1/subscriptions/${subscriptionId}`] as const;
    }

    
export const getGetSubscriptionByIdInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getSubscriptionById>>, TError = unknown>(subscriptionId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSubscriptionById>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSubscriptionByIdQueryKey(subscriptionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubscriptionById>>> = ({ signal }) => getSubscriptionById(subscriptionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(subscriptionId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSubscriptionById>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSubscriptionByIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getSubscriptionById>>>
export type GetSubscriptionByIdInfiniteQueryError = unknown

/**
 * @summary 구독 상세 조회
 */
export const useGetSubscriptionByIdInfinite = <TData = Awaited<ReturnType<typeof getSubscriptionById>>, TError = unknown>(
 subscriptionId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getSubscriptionById>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSubscriptionByIdInfiniteQueryOptions(subscriptionId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetSubscriptionByIdQueryOptions = <TData = Awaited<ReturnType<typeof getSubscriptionById>>, TError = unknown>(subscriptionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionById>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSubscriptionByIdQueryKey(subscriptionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSubscriptionById>>> = ({ signal }) => getSubscriptionById(subscriptionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(subscriptionId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionById>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSubscriptionByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getSubscriptionById>>>
export type GetSubscriptionByIdQueryError = unknown

/**
 * @summary 구독 상세 조회
 */
export const useGetSubscriptionById = <TData = Awaited<ReturnType<typeof getSubscriptionById>>, TError = unknown>(
 subscriptionId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSubscriptionById>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetSubscriptionByIdQueryOptions(subscriptionId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary 구독 활성화
 */
export const activateSubscription = (
    subscriptionId: string,
    activateSubscriptionBody: ActivateSubscriptionBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ActivateSubscription200>(
      {url: `/api/v1/subscriptions/${subscriptionId}/activate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: activateSubscriptionBody
    },
      options);
    }
  


export const getActivateSubscriptionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateSubscription>>, TError,{subscriptionId: string;data: ActivateSubscriptionBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof activateSubscription>>, TError,{subscriptionId: string;data: ActivateSubscriptionBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activateSubscription>>, {subscriptionId: string;data: ActivateSubscriptionBody}> = (props) => {
          const {subscriptionId,data} = props ?? {};

          return  activateSubscription(subscriptionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ActivateSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof activateSubscription>>>
    export type ActivateSubscriptionMutationBody = ActivateSubscriptionBody
    export type ActivateSubscriptionMutationError = unknown

    /**
 * @summary 구독 활성화
 */
export const useActivateSubscription = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateSubscription>>, TError,{subscriptionId: string;data: ActivateSubscriptionBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof activateSubscription>>,
        TError,
        {subscriptionId: string;data: ActivateSubscriptionBody},
        TContext
      > => {

      const mutationOptions = getActivateSubscriptionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary 구독 취소
 */
export const cancelSubscription = (
    subscriptionId: string,
    cancelSubscriptionBody: CancelSubscriptionBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<CancelSubscription200>(
      {url: `/api/v1/subscriptions/${subscriptionId}/cancel`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cancelSubscriptionBody
    },
      options);
    }
  


export const getCancelSubscriptionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelSubscription>>, TError,{subscriptionId: string;data: CancelSubscriptionBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelSubscription>>, TError,{subscriptionId: string;data: CancelSubscriptionBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelSubscription>>, {subscriptionId: string;data: CancelSubscriptionBody}> = (props) => {
          const {subscriptionId,data} = props ?? {};

          return  cancelSubscription(subscriptionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CancelSubscriptionMutationResult = NonNullable<Awaited<ReturnType<typeof cancelSubscription>>>
    export type CancelSubscriptionMutationBody = CancelSubscriptionBody
    export type CancelSubscriptionMutationError = unknown

    /**
 * @summary 구독 취소
 */
export const useCancelSubscription = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelSubscription>>, TError,{subscriptionId: string;data: CancelSubscriptionBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof cancelSubscription>>,
        TError,
        {subscriptionId: string;data: CancelSubscriptionBody},
        TContext
      > => {

      const mutationOptions = getCancelSubscriptionMutationOptions(options);

      return useMutation(mutationOptions);
    }
    